// extracted by mini-css-extract-plugin
export default {"backGroundImage":"SignUpPage_backGroundImage__+YIh7"};